export const REQUEST_TYPES = ['general', 'incident', 'maintenance', 'security', 'suggestions'] as const;

export const REQUEST_TYPE_LABELS: Record<string, string> = {
  general: 'General',
  incident: 'Incident',
  maintenance: 'Maintenance',
  security: 'Security',
  suggestions: 'Suggestions',
};
